import React from "react";
import Layout from "../../../components/common/Layout";
import { ADMIN_NAV } from "../../../utils/navigation";

const PayrollDashboard = () => {
  return (
    <Layout navItems={ADMIN_NAV} panelLabel="Admin Panel">

      <div className="page-header">
        <div>
          <h1 className="page-title">Payroll Dashboard</h1>

          <p className="page-subtitle">
            Process employee payroll, monitor salary cycles and generate payslips.
          </p>
        </div>
      </div>

    </Layout>
  );
};

export default PayrollDashboard;